import React from "react";
import Image from "next/legacy/image";
import { CheckIGButton } from "components/download-app-ctas/download-app-ctas.styles";
import {
  Socials,
  DownloadCTAContainer,
  Wrapper,
  Heading,
  SocialContainer,
  ImgWrapper,
  DownloadText
} from "./social.styles";
import InstagramIcon from "public/assets/instaWhite.png";
import { DownloadAppCTAs } from "components/download-app-ctas/download-app-ctas";
import Mockup from "public/assets/Mockup.jpg";

export const Social: React.FC = () => {
  return (
    <Wrapper>
      <SocialContainer>
        <Heading>
          Masuk kelas melalui website CoLearn pada
          <span> laptop</span> atau <span>aplikasi pada handphone</span>
        </Heading>
        <ImgWrapper>
          <Image
            src={Mockup}
            alt="Whatsapp Icon"
            width={688}
            height={387}
            style={{ marginBottom: "2px" }}
          />
        </ImgWrapper>
        <DownloadText>Download aplikasi sekarang!</DownloadText>
        <Socials>
          <DownloadCTAContainer>
            <DownloadAppCTAs />
            <CheckIGButton
              rel="nofollow"
              href="https://www.instagram.com/colearn.id/"
            >
              Info lengkap? Cek IG CoLearn
              <Image
                src={InstagramIcon}
                alt="Instagram Icon"
                layout="fixed"
                width={18}
                height={18}
                style={{ marginBottom: "2px" }}
              />
            </CheckIGButton>
          </DownloadCTAContainer>
        </Socials>
      </SocialContainer>
    </Wrapper>
  );
};
